import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RightDrawerALV1Component } from './right-drawer-al-v1/right-drawer-al-v1.component';
import { OfferDetailModule } from 'abs-ngx-library/src/lib/offer-detail';
import { CouponListModule } from 'abs-ngx-library/src/lib/coupon-list';
import { ProductGenericGridModule } from 'abs-ngx-library/src/lib/product-generic-grid';
import { OfferQualifiedProductsModule } from 'abs-ngx-library/src/lib/offer-qualified-products';
import { NdcOfferDetailModule } from 'abs-ngx-library/src/lib/ndc-offer-detail';
import { CustomizeProductModule } from 'abs-ngx-library/src/lib/customize-product';
import { QuantityStepperModule } from 'abs-ngx-library/src/lib/quantity-stepper';




@NgModule({
  declarations: [RightDrawerALV1Component],
  exports: [
    RightDrawerALV1Component,
  ],
  imports: [
    CommonModule,
    OfferDetailModule,
    CouponListModule,
    ProductGenericGridModule,
    OfferQualifiedProductsModule,
    NdcOfferDetailModule,
    CustomizeProductModule,
    QuantityStepperModule
  ],
  providers: [
    RightDrawerALV1Component,
  ]
})
export class RightDrawerModule { }
